const state = {
  event_report: ''
}

const mutations = {
  updateEventReport (state, value) {
    state.event_report = value
  },
  clearEventReport (state) {
    mutations.updateEventReport(state, '')
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/event_report.js